import "./HomePage.scss";
import React from "react";
import Header from "../../components/ui/StickyHeader";
import Footer from "./Footer";
import SiteFooter from "../../components/ui/SiteFooter";
import Button from "../../components/ui/Button";
import TextBlock from "../../components/ui/TextBlock";
import SpecTile from "./SpecTile";
import SpecColumnTile from "./SpecColumnTile";
import {
	channelSections,
	enrollmentSteps,
	hero,
} from "./jlrDigitalProgramContent";

const Home = () => {
	return (
		<>
			<Header />

			<div className="hero-container">
				<div className="hero-content-container">
					<TextBlock
						hat="JLR Retailer Digital Program"
						title={
							<>
								Elevate Your Digital Presence with Modern Luxury
								Performance
							</>
						}
						type="h1"
						color="black"
						align="left"
					/>
					<TextBlock
						paragraph="Bring in-market JLR shoppers to your website with data-driven campaigns and expert-led activation."
						type="custom"
						color="black"
						align="left"
						fontWeight={280}
						fontSize={20}
					/>
					<div className="button-container">
						<Button link="/enroll" styleName="black" size="large">
							Enroll now
						</Button>
						<Button
							link="/#channels"
							styleName="outlineBlack"
							size="large">
							Learn more
						</Button>
					</div>
				</div>
				{hero.imageMobile ? (
					<>
						<img
							src={hero.image}
							alt={hero.imageAlt}
							className="hero-image hero-image--desktop"
						/>
						<img
							src={hero.imageMobile}
							alt={hero.imageAlt}
							className="hero-image hero-image--mobile"
						/>
					</>
				) : (
					<img
						src={hero.image}
						alt={hero.imageAlt}
						className="hero-image"
					/>
				)}
			</div>

			<div className="home-container">
				<section
					id="channels"
					className="home-intro-section global-padding">
					<TextBlock
						title={
							<>
								Bring in-market shoppers
								<br />
								to your website
							</>
						}
						paragraph="Select the channels and products that fit your dealership's goals. You control the monthly investment for each that runs always-on."
						type="sectionHeader"
						color="black"
					/>
				</section>

				<div className="spec-tiles-container">
					{channelSections.map((ch) =>
						ch.layout === "columnTile" ? (
							<SpecColumnTile
								key={ch.eyebrow}
								imageSrc={ch.image}
								imageSrcMobile={ch.imageMobile}
								imageAlt={ch.imageAlt}
								eyebrow={ch.eyebrow}
								title={ch.title}
								paragraph={ch.paragraph}
							/>
						) : (
							<SpecTile
								key={ch.eyebrow}
								imageSrc={ch.image}
								imageSrcMobile={ch.imageMobile}
								imageAlt={ch.imageAlt}
								eyebrow={ch.eyebrow}
								title={ch.title}
								paragraph={ch.paragraph}
								variant={ch.variant}
								badges={ch.badges}
							/>
						),
					)}
				</div>

				<section className="enrollment-steps-section global-padding">
					<TextBlock
						title={
							<>
								From enrollment to live <br /> campaigns in 4
								steps.
							</>
						}
						type="sectionHeader"
						color="black"
						align="center"
					/>
					<ol className="enrollment-steps">
						{enrollmentSteps.map((s) => (
							<li key={s.step} className="enrollment-steps__item">
								<span className="enrollment-steps__number">
									{s.step}
								</span>
								<h3 className="enrollment-steps__title">
									{s.title}
								</h3>
								<p className="enrollment-steps__body">
									{s.body}
								</p>
							</li>
						))}
					</ol>
				</section>
			</div>

			<Footer />
			<SiteFooter dark />
		</>
	);
};

export default Home;
